import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class Name extends React.Component {
  render (){
    return (
        <Row style={{marginTop: 15}}>
          <Col sm={12} lg={12} xl={12} md={12} style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>

            <h2 style={{color: 'black', fontSize: '1rem', fontWeight: 'bold' }}>{this.props.Name ? this.props.Name : ""}</h2>
            <p style={{color: 'black', fontSize: '1rem', fontWeight: 'bold'}}>{this.props.Date ? this.props.Date : ""}</p>
            <p style={{color: 'black', fontSize: '1rem', fontStyle: 'italic', margin: 0}}>{this.props.City ? this.props.City : ""}</p>

          </Col>
        </Row>
    )
  }
}

export default Name;
